@use 'sass:map';
@use '../../variables' as *;
@use 'common/assets/scss/global' as *;

.service {
  border-radius: 10px;
  border-top: 11px solid var(--#{$prefix}service);
  background-color: var(--#{$prefix}body-bg);
  box-shadow: var(--#{$prefix}shadow-neutral) HEXToRGBA($black, 0.1);
  padding: 9px 16px 16px;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  width: 100%;
  transition:
    border-color 0.3s ease-out,
    box-shadow 0.3s ease-out;

  > .new {
    position: absolute;
    top: 5px;
    left: -6px;
    padding: 6px 10px;
    border-radius: 4px;
    background-color: var(--#{$prefix}system-red);
    color: $white;
    font-size: var(--#{$prefix}font-size-xxs);
    font-weight: bold;
  }

  > .icon {
    flex: 0 0 auto;
    order: 0;
    height: 40px;
    width: 40px;
    color: HEXToRGBA($black, 0.2);
    transition: color 0.3s ease-out;
    margin-bottom: 8px;
  }

  > img.icon {
    opacity: 0.5;
    transition: opacity 0.3s ease-out;
  }

  > h3 {
    flex: 0 0 auto;
    order: 2;
    margin: 0;

    > a {
      @include unstyled-link;

      &::before {
        content: '';
        position: absolute;
        inset: -11px 0 0;
        z-index: 1;
        border-radius: 10px;
      }

      &:focus-visible {
        outline: none;
      }
    }
  }

  > .category {
    flex: 0 0 auto;
    order: 1;
    font-size: var(--#{$prefix}font-size-xxs);
    opacity: 0.5;
    margin-bottom: 4px;
  }

  > .favorite {
    position: absolute;
    top: 12px;
    right: 12px;
    z-index: 2;
    transition: opacity 0.3s ease-out;

    > button {
      display: inline-flex;
      border-radius: 50%;
      padding: 4px;

      > svg {
        height: 24px;
        width: 24px;
        color: HEXToRGBA($black, 0.2);
        transition: color 0.3s ease-out;
      }

      &.marked > svg {
        color: var(--#{$prefix}favorite);
      }

      &:focus-visible {
        outline: 2px dotted var(--#{$prefix}primary);
      }
    }
  }

  > .more {
    z-index: 2;
    order: 3;
    padding: 4px 8px;
    margin-top: 4px;
    text-decoration: underline;
    color: var(--#{$prefix}system-blue);
    font-family: $sora;
    font-size: var(--#{$prefix}font-size-xs);
    max-height: 2em;
    overflow: hidden;
    transition:
      max-height 0.3s ease-out,
      padding-top 0.3s ease-out,
      padding-bottom 0.3s ease-out,
      margin-top 0.3s ease-out;

    &:focus-visible {
      outline: 2px dotted var(--#{$prefix}system-blue);
      border-radius: 50px;
    }
  }

  @each $type, $values in $categories {
    @if $type == category-default {
      --#{$prefix}service: var(--#{$prefix}#{$type});
      --#{$prefix}service-hover: var(--#{$prefix}#{$type}-hover);
      --#{$prefix}service-hover-shadow: var(--#{$prefix}#{$type}-hover-shadow);
    } @else {
      &.#{$type} {
        --#{$prefix}service: var(--#{$prefix}#{$type});
        --#{$prefix}service-hover: var(--#{$prefix}#{$type}-hover);
        --#{$prefix}service-hover-shadow: var(--#{$prefix}#{$type}-hover-shadow);
      }
    }
  }

  &:hover,
  &:has(:focus-visible) {
    outline: none;
    border-top-color: var(--#{$prefix}service-hover);
    box-shadow: var(--#{$prefix}shadow-strong) var(--#{$prefix}service-hover-shadow);

    > .favorite {
      opacity: 1 !important;
    }

    > .icon {
      color: var(--#{$prefix}service-hover);
    }

    > img.icon {
      opacity: 1;
    }

    > .more {
      max-height: 2em;
      padding-top: 4px;
      padding-bottom: 4px;
      margin-top: 4px;
    }
  }

  @media (width >= map.get($grid-breakpoints, md)) {
    padding: 17px 16px 24px;

    > .category {
      font-size: var(--#{$prefix}font-size-xs);
    }

    > h3 {
      font-size: var(--#{$prefix}font-size-md);
    }
  }

  @media (hover: hover) and (pointer: fine) {
    > .favorite:not(:has(.marked)) {
      opacity: 0;
    }

    > .more {
      max-height: 0;
      padding-top: 0;
      padding-bottom: 0;
      margin-top: 0;
    }
  }

  @media (hover: none) or (pointer: coarse) {
    > .icon {
      color: var(--#{$prefix}service);
    }

    > img.icon {
      opacity: 1;
    }
  }
}
